import ImageLayer from "ol/layer/Image";
import TileLayer from "ol/layer/Tile";
import { Feature, Map } from 'ol';
import { ICAMSKey } from "../Shared/Models/UtilityModels";
import VectorSource from "ol/source/Vector";
import { TileArcGISRest } from "ol/source";
import VectorLayer from "ol/layer/Vector";

export class CAMSTileLayer extends TileLayer {
    DisplayName?: string;
    CanInfoClick?: Boolean;
}

export class CAMSImageLayer extends ImageLayer {
    DisplayName?: string;
    CanInfoClick?: Boolean;
}

export class CAMSVectorLayer extends VectorLayer {
    DisplayName?: string;
    CanInfoClick?: Boolean;
}

export class CAMSMap extends Map {
    getFeatureFromMap?(data: ICAMSKey): Feature;
    convertFeatureToCAMSKey?(feature: Feature): ICAMSKey;
}

export class CAMSVectorSource extends VectorSource {
    private forceRefreshFlag: boolean = false;

    public forceRefresh = (): void => {
        this.forceRefreshFlag = true;
        this.refresh();
    }
}

